import React, { useState } from 'react';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    LinearProgress,
} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { useSnackbar } from 'notistack';
import { updateStatus } from '../../../api/orders';
import FormikTextField from '../../atoms/FormikInput/FormikInput';

interface Props {
    activeAction: string;
    selected: number[];
    onClose: (success: boolean) => void;
    open: boolean;
}

export const OrderCommentDialog = ({ activeAction, selected, onClose, open }: Props) => {
    const { enqueueSnackbar } = useSnackbar();
    const [commentForm] = useState({ comment: '' });

    return (
        <Dialog open={open} fullWidth={true} onClose={() => onClose(false)}>
            <Formik
                enableReinitialize={true}
                initialValues={commentForm}
                validationSchema={Yup.object().shape({
                    comment: Yup.string().required('Введите комментарий'),
                })}
                onSubmit={(values, { setSubmitting }) => {
                    updateStatus({
                        status: activeAction,
                        comment: values.comment,
                        id: selected.length === 1 ? selected[0] : null,
                        ids: selected,
                    })
                        .then(() => {
                            setSubmitting(false);
                            onClose(true);
                        })
                        .catch((err) => {
                            const { message } = err.response.data;
                            enqueueSnackbar(`Ошибка при сохранении данных: ${message}`, {
                                variant: 'error',
                            });
                        });
                }}
            >
                {({ isSubmitting }) => (
                    <Form>
                        <DialogTitle>Комментарий</DialogTitle>
                        <DialogContent>
                            <Box display="flex" flexDirection="column">
                                <Field
                                    component={FormikTextField}
                                    name="comment"
                                    label="Введите комментарий"
                                />
                            </Box>

                            {isSubmitting && <LinearProgress />}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => onClose(false)}>Отмена</Button>
                            <Button type={'submit'}>Ок</Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default OrderCommentDialog;
